import React from "react";
import { money } from "utils/helpers";
import { dedupeItemName, getPerUnitLabel } from "../helpers";

const SpecLine = ({ parts }) => (
  <div className="order-summary-row__spec">
    {parts.map((part, i) => (
      <React.Fragment key={i}>
        {i > 0 && <span className="order-summary-row__dot" />}
        <span>{part}</span>
      </React.Fragment>
    ))}
  </div>
);

const ActionButton = ({
  removed,
  recommendationType,
  onChange,
  onRemove,
  onAddBack,
  itemId,
  changeDisabled,
  changeDisabledHint,
}) => {
  if (removed) {
    return (
      <button
        type="button"
        className="order-summary-row__action-link"
        onClick={() => onAddBack && onAddBack([itemId])}
      >
        Add back
      </button>
    );
  }
  if (recommendationType === "change" && onChange) {
    return (
      <div className="order-summary-row__change-group">
        {changeDisabled && changeDisabledHint && (
          <span className="order-summary-row__change-hint">
            {changeDisabledHint}
          </span>
        )}
        <button
          type="button"
          className="order-summary-row__action-link order-summary-row__action-link--primary"
          onClick={() => onChange(itemId)}
          disabled={!!changeDisabled}
        >
          Change
        </button>
      </div>
    );
  }
  if (recommendationType === "remove" && onRemove) {
    return (
      <button
        type="button"
        className="order-summary-row__action-link"
        onClick={() => onRemove(itemId)}
      >
        Remove
      </button>
    );
  }
  return null;
};

const buildSubParts = (item) => {
  const spec = item.specifications || {};
  const perItem = parseFloat(item.price || 0);
  const isAccessory = item.productType === "accessory";

  if (isAccessory) return ["Add on accessory"];

  const parts = [];
  if (spec.size_desc) {
    parts.push(spec.size_desc);
    if (
      spec.load_speed_rating &&
      !spec.size_desc.includes(spec.load_speed_rating)
    ) {
      parts.push(spec.load_speed_rating);
    }
  } else if (spec.load_speed_rating) {
    parts.push(spec.load_speed_rating);
  } else if (spec.term) {
    parts.push(spec.term);
  }

  if (perItem) parts.push(`$${money(perItem)} ${getPerUnitLabel(item.productType)}`);

  return parts;
};

const OrderSummaryRow = ({
  item,
  removed,
  onChange,
  onRemove,
  onAddBack,
  changeDisabled,
  changeDisabledHint,
}) => {
  const perItem = parseFloat(item.price || 0);
  const lineTotal = perItem * (item.quantity || 1);
  const recType = item.recommendation_type || "none";
  const subParts = buildSubParts(item);

  return (
    <div
      className={
        "order-summary-row" + (removed ? " order-summary-row--removed" : "")
      }
    >
      <div className="order-summary-row__top">
        <div className="order-summary-row__body">
          <div className="order-summary-row__title">
            <span className="order-summary-row__title-text">
              {dedupeItemName(item)}
            </span>
            {removed && (
              <span className="order-summary-row__removed-badge">Removed</span>
            )}
          </div>
          {subParts.length > 0 && <SpecLine parts={subParts} />}
        </div>
        <div className="order-summary-row__total">${money(lineTotal)}</div>
      </div>
      <div className="order-summary-row__bottom">
        <div className="order-summary-row__qty">Qty: {item.quantity || 1}</div>
        <ActionButton
          removed={removed}
          recommendationType={recType}
          onChange={onChange}
          onRemove={onRemove}
          onAddBack={onAddBack}
          itemId={item.id}
          changeDisabled={changeDisabled}
          changeDisabledHint={changeDisabledHint}
        />
      </div>
    </div>
  );
};

export default OrderSummaryRow;
